(function (window) {
  /**
   * Given a BatchGeoStoreLocatorListItem it will return the marker label is
   * for it. This is either a letter (A, B, C, etc) or a number. If you want
   * to render it call #render. This will create a jQuery <div> element with
   * it in there. If you just want the text call #getLabelText.
   *
   * @example
   * // The component requires a list item instance so get that
   * var listItem = BatchGeoStoreLocatorListItem({});
   *
   * // Now pass the instance in and you'll get a marker label
   * var markerLabel = new window.BatchGeoStoreLocatorMarkerLabel(listItem);
   *
   * // Adds a div element with a class with the label as the text to the
   * // .example element
   * $('.ex').append(markerLabel.render())
   *
   * // This will just render the text of the label text such as "A"
   * console.log(markerLabel.getLabelText())
   *
   * @param {BatchGeoStoreLocatorListItem} listItemInstance The label is
   * created based on the properties in locator list item so you must pass a
   * reference in.
   *
   * @return {BatchGeoStoreLocatorMarkerLabel}
   *
   * @constructor
   */
  var BatchGeoStoreLocatorMarkerLabel = function (listItemInstance) {
    this.index = listItemInstance.getModel().index;
    this.labelType = window.per.labeltype_sel;
    return this;
  };

  /**
   * If there's a label it creates an element, a jQuery <div>, for you to
   * render it somewhere like another element. This is assuming you will be
   * using jQuery to (a|pre)ppend or use `html` property and that's why it
   * returns null. Returning null makes it so jQuery renders nothing.
   *
   * This will break for you though if you're trying to do jQuery methods
   * chained to render without checking null.
   *
   * @return {jQuery|null} If there's a label to be rendered it will return a
   * jQuery <div> element. If there is no label to render it will return null.
   */
  BatchGeoStoreLocatorMarkerLabel.prototype.render = function () {
    var label = this.getLabelText(this.index);

    return !label
      ? null
      : $("<div />", {
          class: "storeLocator-marker-label",
          text: label,
        });
  };

  /**
   * Returns the label in text form such as A or 1 for example. If there is no
   * label for the marker it will return null.
   *
   * @return {string|null|number} Returns a value that you should be able to
   * display or use in most cases. If it's a letter type it returns a string.
   * If it's a number type it returns a number. If there's no label that
   * should be rendered it returns null.
   */
  BatchGeoStoreLocatorMarkerLabel.prototype.getLabelText = function () {
    var index = this.index;

    switch (this.labelType) {
      case "numbers":
        return index + 1;
      case "letters":
        return "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[index];
      default:
        return null;
    }
  };

  return (window.BatchGeoStoreLocatorMarkerLabel =
    BatchGeoStoreLocatorMarkerLabel);
})(window);
